export default __webpack_public_path__ + "static/media/info.df6ff0ff.svg";